/**
 * Cabecalho fino do wizard em tela cheia.
 *
 * Substitui o banner do estabelecimento na rota /[slug]/agendar: so o caminho
 * de volta ao perfil e o nome da unidade, para que a primeira etapa comece no
 * topo da tela.
 */

import Link from "next/link";
import { FiArrowLeft } from "react-icons/fi";

interface BookingWizardTopBarProps {
  establishmentName: string;
  backHref: string;
}

export function BookingWizardTopBar({
  establishmentName,
  backHref,
}: BookingWizardTopBarProps) {
  return (
    <header
      data-testid="booking-wizard-topbar"
      className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/95 backdrop-blur"
    >
      <div className="mx-auto flex h-14 max-w-[1280px] items-center gap-2 px-2 sm:px-4">
        <Link
          href={backHref}
          aria-label={`Voltar ao perfil de ${establishmentName}`}
          className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-xl text-slate-700 transition hover:bg-slate-100 hover:text-primary-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-100"
        >
          <FiArrowLeft className="h-5 w-5" aria-hidden="true" />
        </Link>
        <p className="min-w-0 flex-1 truncate text-base font-bold text-[#233055]">
          {establishmentName}
        </p>
      </div>
    </header>
  );
}
